// extracted by mini-css-extract-plugin
module.exports = {"componentWrapper":"loader-switch_componentWrapper__17B8T","subscriptionWrapper":"loader-switch_subscriptionWrapper__324gU","introWrapper":"loader-switch_introWrapper__31a3T"};